const systemConfig = {
    state: {
        searchLen: 0,
        loginName: '',
        asideCollapse: false,
        isSubmitted: false,
    },
    mutations: {
        CHANGE_SEARCHLEN (state, length) {
            state.searchLen = length
        },
        CHANGE_LOGINNAME (state, name) {
            state.loginName = name
        },
        CHANGE_COLLAPSE (state, status) {
            state.asideCollapse = status
        },
        changeIsSubmitted (state, status) {
            state.isSubmitted = status
        },
    },
    actions: {
        LOGINSUCCESSLOAD ({ commit, state }) {

        }
    }
}

export default systemConfig
